"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scores_1 = require("./scores");
exports.buckets = {
  20: 'low',
  40: 'below-average',
  60: 'average',
  80: 'above-average',
  100: 'high'
};
exports.getColor = function (score) {
  return "" + exports.buckets[scores_1.findOrDefaultByScore(score, exports.buckets)];
};